import withStyles from '@material-ui/core/styles/withStyles';

export default withStyles(() => ({
    root: {
        border: '1px solid red'
    },
    treeItem: {
        paddingLeft: 0,
    },
    checkedCategory: {
        paddingTop: 9,
    },
    test: {
        border: '2px solid green'
    }
}));